import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';
import { IBankState, JwtPayload } from '../types';

const extractUserDataFromToken = (
  token: string
): { iin: string | null; phone: string | null } => {
  try {
    const decoded = jwtDecode(token) as JwtPayload;
    const iin = decoded.add_info?.iin ?? null;
    const phone = decoded.add_info?.phone ?? null;
    return { iin, phone };
  } catch (error) {
    console.error('Error decoding token:', error);
    return { iin: null, phone: null };
  }
};

const initialState: IBankState = {
  token: null,
  iin: null,
  phone: null,
};

export const bankSlice = createSlice({
  name: 'bank',
  initialState,
  reducers: {
    reset: () => initialState,
    setBankToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      const { iin, phone } = extractUserDataFromToken(action.payload);
      state.iin = iin;
      state.phone = phone;

      // console.log('iin', state.iin);
      // console.log('phone', state.phone);
    },
  },
});

export const { setBankToken } = bankSlice.actions;

export default bankSlice.reducer;
